/**
 * @desc 添加售后服务信息
 */

import { RequestConfig, request } from 'umi';

function req(
  data: defs.store.AfterSaleStoreInfoDTO,
  config: Parameters<typeof request>[1] = {},
) {
  return request<defs.store.GeneralHttpResponse<boolean>>(
    `/storeapi/inner/after/sale/service/info`,
    {
      data,
      method: 'post',
      ...(config || {}),
    },
  );
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.GeneralHttpResponse<boolean>;
export default req;
